<template>
  <div>
    <div class="border-title-wrap">
      <div class="title"><slot></slot></div>
      <div class="border"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.border-title-wrap {
  display: inline-block;
  .title {
    color: #333;
  }
  .border {
    margin-top: -6px;
    height: 6px;
    background: rgb(216, 228, 239);
    border-radius: 3px;
  }
}
</style>